






























































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import http from "@/axios/http-common";
import DataRiwayat from "@/services/DataRiwayat";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import OrderBankDarahSvc from "@/services/OrderBankDarah";
import SerahTerimaKantongSvc from "@/services/SerahTerimaKantongDarah";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import { RekapSerahTerimaRow } from "@/types/order_bank_darah";
import { OpsiTeks, SerahTerimaKantongDarah } from "@/types/serah_terima_kantong_darah";
import { composeDate, toDateString, toTimeString } from "@/utils/asesmenIntensifDateTime";

type OpsiRegistrasi = { label: string; row: RekapSerahTerimaRow };

function formKosong(): SerahTerimaKantongDarah {
  return {
    id: null,
    tanggal_crosstest: moment().format("YYYY-MM-DD"),
    serah_terima_sampel_darah_id: null,
    no_registrasi_sampel: null,
    no_layanan: null,
    register_id: null,
    pasien_rm: null,
    pasien_nama: null,
    bangsal: null,
    jaminan: null,
    golongan_darah: null,
    komponen: null,
    komponen_lain: null,
    jumlah: null,
    nomor_kantong: [],
    diambil_at: moment().format("YYYY-MM-DD HH:mm:00"),
    keterangan: null,
    petugas_bangsal_nama: null,
    petugas_bdrs_nama: null
  };
}

@Component({ components: { VCDateTimePicker } })
export default class SerahTerimaKantongDarahDialog extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ default: null }) readonly editData!: SerahTerimaKantongDarah | null;
  @Prop({ type: Array, default: () => [] }) readonly komponenOptions!: OpsiTeks[];

  readonly golonganItems = ["A", "B", "O", "AB"];

  form: SerahTerimaKantongDarah = formKosong();
  saving = false;
  registrasiItems: OpsiRegistrasi[] = [];
  memuatRegistrasi = false;
  pilihanRegistrasi: OpsiRegistrasi | string | null = null;
  pasienItems: any[] = [];
  pasienTerpilih: any = null;
  cariPasien: string | null = null;
  memuatPasien = false;
  registerItems: { value: string; text: string; unit: string | null }[] = [];
  memuatRegister = false;

  get tglCrosstest(): Date | null {
    return composeDate(this.form.tanggal_crosstest);
  }
  set tglCrosstest(val: Date | null) {
    this.form.tanggal_crosstest = val ? toDateString(val) : null;
  }

  get diambilAt(): Date | null {
    const v = this.form.diambil_at;
    return v ? composeDate(v.slice(0, 10), v.slice(11, 16)) : null;
  }
  set diambilAt(val: Date | null) {
    this.form.diambil_at = val ? `${toDateString(val)} ${toTimeString(val)}:00` : null;
  }

  @Watch("value")
  onBuka(val: boolean) {
    if (!val) return;

    this.form = this.editData
      ? { ...formKosong(), ...this.editData, nomor_kantong: [...(this.editData.nomor_kantong || [])] }
      : { ...formKosong(), petugas_bdrs_nama: (userModule.user && userModule.user.nama) || null };
    this.pilihanRegistrasi = this.form.no_registrasi_sampel || null;
    this.pasienTerpilih = null;
    this.pasienItems = [];
    this.registerItems = this.form.register_id
      ? [{ value: String(this.form.register_id), text: `No. ${this.form.register_id}`, unit: null }]
      : [];
    this.muatRegistrasi();
  }

  @Watch("form.nomor_kantong")
  onNomorKantong(val: string[], lama: string[]) {
    const n = (val || []).length;
    const sebelum = (lama || []).length;
    if (!this.form.jumlah || this.form.jumlah === sebelum) this.form.jumlah = n || null;
  }

  async muatRegistrasi() {
    this.memuatRegistrasi = true;
    try {
      const res = await OrderBankDarahSvc.daftarSerahTerima({
        tgl_start: moment().subtract(30, "days").format("YYYY-MM-DD"),
        tgl_end: moment().format("YYYY-MM-DD"),
        final: "ya"
      });
      this.registrasiItems = res.rows.map(row => ({
        label: `${row.nomor || "-"} — ${row.pasien_nama || "-"} (${row.pasien_rm})`,
        row
      }));
    } catch {
      this.registrasiItems = [];
    } finally {
      this.memuatRegistrasi = false;
    }
  }

  onRegistrasi(val: OpsiRegistrasi | string | null) {
    this.pilihanRegistrasi = val;

    if (val && typeof val === "object") {
      const r = val.row;
      this.form.serah_terima_sampel_darah_id = r.id;
      this.form.no_registrasi_sampel = r.nomor;
      this.form.register_id = String(r.register_id);
      this.form.pasien_rm = String(r.pasien_rm);
      this.form.pasien_nama = r.pasien_nama;
      this.form.bangsal = r.bangsal || r.unit_pemohon.nama;
      this.form.jaminan = this.form.jaminan || r.jaminan;
      this.form.golongan_darah = this.form.golongan_darah || r.golongan_darah;
      return;
    }

    this.form.serah_terima_sampel_darah_id = null;
    this.form.no_registrasi_sampel = val ? String(val) : null;
  }

  labelPasien(item: any): string {
    return item && typeof item === "object" ? `${item.rm} — ${item.nama}` : "";
  }

  async cariDataPasien() {
    if (!this.cariPasien) return;
    this.memuatPasien = true;
    try {
      const res = await http.getDataParam("/pasien", { params: { term: this.cariPasien } });
      this.pasienItems = res.data || [];
    } catch {
      this.pasienItems = [];
    } finally {
      this.memuatPasien = false;
    }
  }

  async onPasien(p: any) {
    this.registerItems = [];
    this.form.register_id = null;

    if (!p || typeof p !== "object") return;

    this.form.pasien_rm = String(p.rm);
    this.form.pasien_nama = p.nama;
    this.memuatRegister = true;

    try {
      const resp = await DataRiwayat.getDataRiwayatRm(String(p.rm), "");
      const list: any[] = Array.isArray(resp && resp.data) ? resp.data : [];
      this.registerItems = list.map(r => ({
        value: String(r.register),
        text: `${r.masuk ? moment(r.masuk).format("DD-MM-YYYY") : "-"} — ${(r.unit && r.unit.nama) || "-"} (No. ${r.register})`,
        unit: (r.unit && r.unit.nama) || null
      }));
      if (this.registerItems.length) {
        this.form.register_id = this.registerItems[0].value;
        this.onRegister(this.form.register_id);
      }
    } catch {
      this.registerItems = [];
    } finally {
      this.memuatRegister = false;
    }
  }

  onRegister(register: string | null) {
    const pilihan = this.registerItems.find(r => r.value === register);
    if (pilihan && pilihan.unit) this.form.bangsal = pilihan.unit;
  }

  cekIsian(): string | null {
    const kurang: string[] = [];
    if (!this.form.pasien_rm) kurang.push("Pasien");
    if (!this.form.komponen) kurang.push("Komponen");
    if (this.form.komponen === "lainnya" && !this.form.komponen_lain) kurang.push("Sebutkan Komponen");
    if (!this.form.nomor_kantong.length) kurang.push("No Kantong");
    if (!this.form.jumlah || this.form.jumlah < 1) kurang.push("Jumlah");
    if (!this.form.diambil_at) kurang.push("Tanggal & Jam Diambil");
    return kurang.length ? "Lengkapi dulu: " + kurang.join(", ") + "." : null;
  }

  async simpan() {
    const kurang = this.cekIsian();
    if (kurang) {
      appModule.sendErrorAlert(kurang);
      return;
    }

    this.saving = true;
    try {
      const res = await SerahTerimaKantongSvc.simpan({
        ...this.form,
        komponen_lain: this.form.komponen === "lainnya" ? this.form.komponen_lain : null
      });
      appModule.sendSuccessNotice(res.message);
      this.$emit("saved");
      this.$emit("input", false);
    } catch {
      return;
    } finally {
      this.saving = false;
    }
  }
}
